
import React, { useImperativeHandle, forwardRef, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Modal } from 'bootstrap'; // Import Bootstrap Modal

const Header = forwardRef((props, ref) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('login');
  const [modal, setModal] = useState(null);
  
  const [loginFormData, setLoginFormData] = useState({
    email: '',
    password: ''
  });

  const [registerFormData, setRegisterFormData] = useState({
    name: '',
    email: '',
    password: '',
    contactNumber: '',
    businessName: '',
    RegisterFrom: 'Refmex'
  });

  // Initialize Bootstrap modal when component mounts
  useEffect(() => {
    const modalElement = document.getElementById('LoginForm');
    if (modalElement) {
      const bsModal = new Modal(modalElement, {
        backdrop: true,
        keyboard: true
      });
      setModal(bsModal);
    }
  }, []);
  useImperativeHandle(ref, () => ({
    showLoginModal: () => {
      setActiveTab('login');
      openModal();
    },
    showRegisterModal: () => {
      setActiveTab('register');
      openModal();
    }
  }));
  // Function to check if current path matches nav item
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  }

  const openModal = () => {
    if (modal) {
      modal.show();
    }
  };

  const closeModal = () => {
    if (modal) {
      modal.hide();
    }
    resetForms();
  };

  const resetForms = () => {
    setLoginFormData({
      email: '',
      password: ''
    });
    setRegisterFormData({
      name: '',
      email: '',
      password: '',
      contactNumber: '',
      businessName: '',
      RegisterFrom: 'Refmex'
    });
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setRegisterFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleLoginInputChange = (e) => {
    const { id, value } = e.target;
    setLoginFormData((prevState) => ({
      ...prevState,
      [id === "loginEmail" ? "email" : "password"]: value,
    }));
  };

  const handleLoginSubmit = async (e) => {
    if (e) e.preventDefault();
    
    // Encode the login credentials
    const payload = btoa(JSON.stringify({
      email: loginFormData.email,
      password: loginFormData.password,
      LoginFrom: 'Refmex',
      LoginUrl:`${process.env.REACT_APP_Refmex_URL}`

    }));
    
    // Redirect to receipt system's login handler
    window.location.href = `${process.env.REACT_APP_RECEIPT_LOGIN_REDIRECT}/external-login?payload=${encodeURIComponent(payload)}`;
  };

  const handleRegisterSubmit = async (e) => {
    if (e) e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_RECEIPT_URL}/add_user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(registerFormData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error response:', errorData);
        Swal.fire({
          position: "center",
          icon: "error",
          title: errorData.msg.charAt(0).toUpperCase() + errorData.msg.slice(1),
          showConfirmButton: true
        });
        throw new Error('Registration failed');
      }
      const payload = btoa(JSON.stringify({
        email: registerFormData.email,
        password: registerFormData.password,
        LoginFrom: 'Refmex',
        LoginUrl:`${process.env.REACT_APP_Refmex_URL}`
  
      }));
      
      // Redirect to receipt system's login handler
      window.location.href = `${process.env.REACT_APP_RECEIPT_LOGIN_REDIRECT}/external-login?payload=${encodeURIComponent(payload)}`;

    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top">
        <div className="container">
          {/* <a className='navbar-brand' href='/'>Feedmex<b>.</b></a> */}
          <a className='navbar-brand' href="/"> <img src="images/logo.png"  alt="" /> </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <i className="fa fa-bars" aria-hidden="true"></i>
          </button>
          <div className="collapse navbar-collapse menu-main" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto menu-item">
              <li className="nav-item">
                <a className={`nav-link ${isActive('/')}`} href="/">Home</a>
              </li>
              <li className="nav-item">
                <a className={`nav-link ${isActive('/about-us')}`} href="/about-us">About Us</a>
              </li>
              <li className="nav-item">
                <a className={`nav-link ${isActive('/pricing')}`} href="/pricing">Pricing</a>
              </li>
              {/* <li className="nav-item">
                <a className={`nav-link ${isActive('/developer-docs')}`} href="/developer-docs">Developer Docs</a>
              </li> */}
              {/* <li className="nav-item">
                <a className="nav-link bor" href="#" onClick={(e) => {
                  e.preventDefault();
                  setActiveTab('login');
                  openModal();
                }}>Login</a>
              </li> */}
              <li className="nav-item">
                <a
                  className="nav-link bor"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    const contactModal = new Modal(document.getElementById('ContactModal'), {
                      backdrop: true,
                      keyboard: true
                    });
                    contactModal.show();
                  }}
                >
                  Contact Us
                </a>
              </li>

            </ul>
          </div>
        </div>
      </nav>

      {/* Login/Register Modal - Using proper Bootstrap modal */}
      <div className="modal fade" id="LoginForm" tabIndex="-1" aria-labelledby="LoginFormLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="LoginFormLabel">{activeTab === 'login' ? 'Login' : 'Register'}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="tab-content mt-3">
                <div className={`tab-pane fade ${activeTab === 'login' ? 'show active' : ''}`} id="login" role="tabpanel">
                  <form id='login_form' onSubmit={handleLoginSubmit}>
                    <div className="input-group custom-form-input">
                      <div className="input-group-prepend">
                        <span className="input-group-text faq-icon">
                          <i aria-hidden="true">
                            <img width="25" height="25" src="https://img.icons8.com/ios-glyphs/25/d98b05/user--v1.png" alt="user" />
                          </i>
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control box-bg contact-input"
                        id="loginEmail"
                        placeholder="Enter Username Or Email"
                        value={loginFormData.email}
                        onChange={handleLoginInputChange}
                        // onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                      />
                    </div>
                    <div className="input-group custom-form-input">
                      <div className="input-group-prepend">
                        <span className="input-group-text faq-icon">
                          <i aria-hidden="true">
                            <img width="25" height="25" src="https://img.icons8.com/ios-glyphs/25/d98b05/lock.png" alt="lock" />
                          </i>
                        </span>
                      </div>
                      <input
                        type="password"
                        id="loginPassword"
                        className="form-control box-bg contact-input"
                        placeholder="Enter your password"
                        value={loginFormData.password}
                        onChange={handleLoginInputChange}
                        // onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                      />
                    </div>
                  </form>
                </div>

                <div className={`tab-pane fade ${activeTab === 'register' ? 'show active' : ''}`} id="register" role="tabpanel">
                  <form id='signup_form' onSubmit={handleRegisterSubmit}>
                    <div className="input-group custom-form-input mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text faq-icon">
                          <i aria-hidden="true">
                            <img width="25" height="25" src="https://img.icons8.com/ios-glyphs/25/d98b05/user--v1.png" alt="user" />
                          </i>
                        </span>
                      </div>
                      <input
                        type="text"
                        id="name"
                        className="form-control box-bg contact-input"
                        placeholder="Enter your name"
                        value={registerFormData.name}
                        onChange={handleInputChange}
                        // onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                      />
                    </div>
                    <div className="input-group custom-form-input mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text faq-icon">
                          <i aria-hidden="true">
                            <img width="25" height="25" src="https://img.icons8.com/ios-glyphs/25/d98b05/email.png" alt="email" />
                          </i>
                        </span>
                      </div>
                      <input
                        type="email"
                        id="email"
                        className="form-control box-bg contact-input"
                        placeholder="Enter your email"
                        value={registerFormData.email}
                        onChange={handleInputChange}
                        // onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                      />
                    </div>
                    <div className="input-group custom-form-input mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text faq-icon">
                          <i aria-hidden="true">
                            <img width="25" height="25" src="https://img.icons8.com/ios-glyphs/25/d98b05/lock.png" alt="lock" />
                          </i>
                        </span>
                      </div>
                      <input
                        type="password"
                        id="password"
                        className="form-control box-bg contact-input"
                        placeholder="Enter your password"
                        value={registerFormData.password}
                        onChange={handleInputChange}
                        // onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                      />
                    </div>
                    <div className="input-group custom-form-input mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text faq-icon">
                          <i aria-hidden="true">
                            <img width="25" height="25" src="https://img.icons8.com/ios-glyphs/25/d98b05/phone.png" alt="phone" />
                          </i>
                        </span>
                      </div>
                      <input
                        type="number"
                        id="contactNumber"
                        className="form-control box-bg contact-input"
                        placeholder="Enter your contact number"
                        value={registerFormData.contactNumber}
                        onChange={handleInputChange}
                        // onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                      />
                    </div>
                    <div className="input-group custom-form-input mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text faq-icon">
                          <i aria-hidden="true">
                            <img width="25" height="25" src="https://img.icons8.com/ios-glyphs/25/d98b05/business.png" alt="business" />
                          </i>
                        </span>
                      </div>
                      <input
                        type="text"
                        id="businessName"
                        className="form-control box-bg contact-input"
                        placeholder="Enter your business name"
                        value={registerFormData.businessName}
                        onChange={handleInputChange}
                        // onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-between">
              <div>
                {activeTab === 'login' ? (
                  <p style={{ color: 'white',fontSize:'small' }}>
                    Don't have an account?{' '}
                    <span onClick={() => setActiveTab('register')} style={{ cursor: 'pointer', color: '#0553d9' }}>
                      Register here
                    </span>
                  </p>
                ) : (
                  <p style={{ color: 'white', fontSize:'small' }}>
                    Already have an account?{' '}
                    <span onClick={() => setActiveTab('login')} style={{ cursor: 'pointer', color: '#0553d9' }}>
                      Login here
                    </span>
                  </p>
                )}
              </div>
              <div className='d-flex' >
                <button type="button" className="btn dropboxx2" style={{ marginRight: '10px' }} onClick={closeModal}>
                  Close
                </button>
                {activeTab === 'login' ? (
                  <button type="submit" form="login_form" className="btn dropboxx2" >
                    Login
                  </button>
                ) : (
                  <button type="submit" form="signup_form" className="btn dropboxx2" >
                    Register
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default Header;